export const ID_WORKSHOP_PRODUCT_OFFICIAL_CHECK_UP = 1
export const ID_WORKSHOP_PRODUCT_BATTERY = 2
export const ID_WORKSHOP_PRODUCT_WIPER_BLADE = 3
export const ID_WORKSHOP_PRODUCT_SANITATION = 4
export const ID_WORKSHOP_PRODUCT_AIR_CONDITIONING = 5
export const ID_WORKSHOP_PRODUCT_BATTERY_START_STOP = 6
export const ID_WORKSHOP_PRODUCT_PRE_INSPECTION_CHECK_UP = 7
